<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path fill="#21468B" d="M18.477 13H1.523c1.237 3.493 4.56 6 8.477 6s7.24-2.507 8.477-6z"/><path fill="#FFF" d="M19 10c0-1.054-.19-2.06-.523-3H1.523C1.19 7.94 1 8.946 1 10s.19 2.06.523 3h16.954c.333-.94.523-1.946.523-3z"/><path fill="#AE1C28" d="M10 1C6.083 1 2.76 3.507 1.523 7h16.954C17.24 3.507 13.917 1 10 1z"/><g fill="none"><circle cx="10" cy="10" r="9"/><circle cx="10" cy="10" r="9.5" stroke="#E4E4E4"/></g></svg>
</template>

<script>
  export default {
    name: 'nl-NL',
  };
</script>
